import { localize } from '@/utils/i18n'

export const text = {
    inputPlaceholder: localize({
        ru: 'Введите ключевое слово',
        en: 'Enter keywords',
        cn: 'Enter keywords'
    }),
    description: localize({
        ru: 'По&nbsp;Вашему запросу ничего не&nbsp;нашлось.',
        en: 'Sorry, no matches were found for your request. Try changing your search terms.',
        cn: 'Sorry, no matches were found for your request. Try changing your search terms.'
    }),
    resetFilters: localize({
        ru: 'Сбросить фильтры',
        en: 'Reset filters',
        cn: 'Reset filters'
    }),
    sorting: localize({
        ru: 'Сортировка:',
        en: 'Sorting:',
        cn: 'Sorting:'
    }),
    section: localize({
        ru: 'Раздел:',
        en: 'Section:',
        cn: 'Section:'
    }),
    date: localize({
        ru: 'Выбрать период',
        en: 'Date',
        cn: 'Date'
    }),
    resetFilter: localize({
        ru: 'Сбросить фильтр',
        en: 'Reset',
        cn: 'Reset'
    }),
    tags: localize({
        ru: 'Теги',
        en: 'Tags',
        cn: 'Tags'
    })
}
